import { render, staticRenderFns } from "./FaqCategories.vue?vue&type=template&id=6ed52dc4&scoped=true&"
import script from "./FaqCategories.vue?vue&type=script&lang=js&"
export * from "./FaqCategories.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategories.vue?vue&type=style&index=0&id=6ed52dc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed52dc4",
  null
  
)

component.options.__file = "FaqCategories.vue"
export default component.exports